import { z } from "zod/v4";

export const BrowserlessBqlResponseSchema = z.object({
  data: z.object({
    reject: z
      .object({
        enabled: z.boolean(),
        time: z.number(),
      })
      .optional(),
    goto: z
      .object({
        status: z.number(),
      })
      .optional(),
    html: z
      .object({
        html: z.string(),
      })
      .optional(),
    fullHTML: z
      .object({
        html: z.string(),
      })
      .optional(),
    screenshot: z.object({ base64: z.string() }),
  }),
  errors: z
    .array(
      z.object({
        message: z.string(),
      })
    )
    .optional(),
});

export type BrowserlessBqlResponseType = z.infer<
  typeof BrowserlessBqlResponseSchema
>;
